import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    routeViewPreferences: translate({ id: 'form.drivers.driverApp.routeViewPreferences' }),
    mobileFutureDaysVisibility: translate({
      id: 'form.drivers.view.labels.mobileFutureDaysVisibility',
    }),
    mobileFutureDaysVisibilityValues: (
      mobileFutureDaysVisibility: uui.domain.client.rm.MobileFutureDaysVisibility,
    ) => {
      switch (mobileFutureDaysVisibility) {
        case -1:
          return translate({
            id: 'form.drivers.view.values.mobileFutureDaysVisibility.allDays',
          })
        case 2:
          return translate({
            id: 'form.drivers.view.values.mobileFutureDaysVisibility.todayAndNextTwoDays',
          })
        default:
          return mobileFutureDaysVisibility
      }
    },
  }))

  return api
}
